import WidgetEventContentItemResourceModel from '../../generated/types/model/resource/WidgetEventContentItemResourceModel';

export default class WidgetEventContentItemResourceViewModel extends WidgetEventContentItemResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
